import fetch from "auth/FetchInterceptor";

const AuthService = {};
const baseAuthUrl = "api/Authenticate";

AuthService.login = function (data) {
  return fetch({
    url: `${baseAuthUrl}/login`,
    method: "post",
    data: data,
  });
};

AuthService.register = function (data) {
  return fetch({
    url: `${baseAuthUrl}/register`,
    method: "post",
    data: data,
  });
};

export default AuthService;
